module.exports = __webpack_public_path__ + "media/ballrooms.a4612399.jpg";